import React from "react";
import styled from "styled-components";
import { colors, font, fontSizing, THEME_SCALE } from "../../theme";
import { Contract } from "../icons";
import Button from "../Button";
import { RouteName, RouteParams } from "../../../lib/routes";
import { ContentRef } from "../../../lib/CmsApi";

const Wrapper = styled.div`
  background-color: ${colors.paleGreyTwo};
  color: ${colors.blue};
  display: flex;
  flex-direction: column;
  font-size: ${font.sizeXS};
  text-align: center;
  margin: 0 0 0 auto;
  width: 100%;
  max-width: 500px;
  padding: calc((4px * 8) * ${THEME_SCALE});
`;
const ContractWrapper = styled.div`
  padding: 4px calc(4px * 5) 0 0;
  margin-left: -3px;
  > svg {
    width: 1em;
    height: 1em;
  }
`;
const Flex = styled.div`
  display: flex;
  width: 100%;
`;
const InfoBoxTitle = styled.div`
  margin-bottom: calc(4px * 4);
  ${fontSizing("label", 20)}
  text-align: left;
`;
const StyledButton = styled(Button)`
  margin: 0 auto;
`;

export interface InfoBoxProps {
  title: string;
  ctaLabel?: string;
  ctaRef?: ContentRef | { route: RouteName; params?: RouteParams };
  className?: string;
}

const InfoBox: React.FC<InfoBoxProps> = props => {
  const { className } = props;
  return (
    <Wrapper className={className}>
      <Flex>
        <ContractWrapper>
          <Contract />
        </ContractWrapper>
        <InfoBoxTitle>{props.title}</InfoBoxTitle>
      </Flex>
      {props.ctaLabel && props.ctaRef && (
        <StyledButton
          ghost
          small
          bold
          href={"_url" in props.ctaRef ? props.ctaRef._url : undefined}
          route={"route" in props.ctaRef ? props.ctaRef.route : undefined}
          params={"params" in props.ctaRef ? props.ctaRef.params : undefined}
        >
          {props.ctaLabel}
        </StyledButton>
      )}
    </Wrapper>
  );
};

export default InfoBox;
